module.exports = __webpack_public_path__ + "static/img/code.78022ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/code.png
// module id = EF7e
// module chunks = 1